import {Theme} from "@material-ui/core";

export const styles = (theme:Theme) => {
    return {
        title: {
            marginBottom: theme.spacing(2)
        },
    }
};